import { render, staticRenderFns } from "./productReturn.vue?vue&type=template&id=3688a42e"
import script from "./productReturn.vue?vue&type=script&lang=js"
export * from "./productReturn.vue?vue&type=script&lang=js"
import style0 from "./productReturn.vue?vue&type=style&index=0&id=3688a42e&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3688a42e')) {
      api.createRecord('3688a42e', component.options)
    } else {
      api.reload('3688a42e', component.options)
    }
    module.hot.accept("./productReturn.vue?vue&type=template&id=3688a42e", function () {
      api.rerender('3688a42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wareHouse/productReturn.vue"
export default component.exports